export const set = (element, attribute, value) => {
  if (element) {
    element.setAttribute(`data-${attribute}`, value)
  } else {
    console.log(`!!! WARNING (DOM.fns.dataset.set): Unable to set attribute (${attribute}) on element.`, element)
  }
}
